import { Box, Flex, List, ListIcon, ListItem, Stack, Text } from '@chakra-ui/react';
import { MdCheckCircle } from 'react-icons/md';
import React from 'react';

const DisplaySub = ({ planName, priceAmount, features, radioButtonProps, isSelected }) => {
    const isChecked = radioButtonProps?.isChecked || isSelected; // Get the checked state
    return (
        <Stack
            spacing='0'
            alignItems='center'
            w='100%'
            borderRadius='8px'
            borderWidth='1px' // Use borderWidth for consistency
            borderColor={isChecked ? 'blue.300' : '#E2E8F0'} // Change border color when checked
            bg={isChecked ? 'blue.50' : 'transparent'} // Change background color when checked
            position='relative'
        >
            <Text
                mt='20px'
                fontSize='20px'
                lineHeight='24px'
                minH='24px'
                fontWeight='700'
                whiteSpace='normal'
                overflowWrap='break-word'
            >
                {planName}
            </Text>
            <Text textAlign='center' mt='38px' fontSize='30px' minH='36px' lineHeight='36px' fontWeight='700'>
                ${priceAmount}
            </Text>
            <Text fontSize='12px' lineHeight='18px' fontWeight='400'>
                /mo
            </Text>
            <Box mt='20px' textAlign='left' w='100%' pl='15px'>
                <Text fontSize='12px' lineHeight='18px' fontWeight='400'>
                    Includes:
                </Text>
                <List mb='20px' height='150px' overflowY='auto'>
                    {features?.map((feature) => (
                        <ListItem key={feature}>
                            <Flex alignItems='center'>
                                <ListIcon color='#0000007A' w='20px' h='20px' as={MdCheckCircle} />
                                {/* Ensure feature text wraps */}
                                <Text
                                    color='#000000A3'
                                    fontSize='12px'
                                    lineHeight='24px'
                                    fontWeight='400'
                                    whiteSpace='normal'
                                    overflowWrap='break-word'
                                >
                                    {feature}
                                </Text>
                            </Flex>
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Stack>
    );
};

// Export renamed component
export default DisplaySub;
